//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "BODE",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
      },
      item1List: [
        { value: '0', name: '≥65' },
        { value: '1', name: '50-64' },
        { value: '2', name: '36-49' },
        { value: '3', name: '≤35' }
      ],
      item2List: [
        { value: '0', name: '≥350' },
        { value: '1', name: '250-349' },
        { value: '2', name: '150-249' },
        { value: '3', name: '≤149' }
      ],
      item3List: [
        { value: '0', name: '1' },
        { value: '1', name: '2' },
        { value: '2', name: '3' },
        { value: '3', name: '4' }
      ],
      item4List: [
        { value: '0', name: '>21' },
        { value: '1', name: '≤21' },
      ],
      text: ''
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 + form.item2 + form.item3 + form.item4
        if (result < 3) {
          self.text = '轻度'
        } else if (result < 5) {
          self.text = '中度'
        } else if (result < 7) {
          self.text = '重度'
        } else {
          self.text = '极重度'
        }
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/BODE.vue